module.exports = ".selected {\n  background-color: rgba(178, 238, 242, 0.3); }\n\n.item {\n  cursor: pointer; }\n\n.item:hover {\n    background-color: rgba(178, 238, 242, 0.3); }\n\n.container {\n  margin: 5px;\n  margin-right: 15px; }\n\n.del-icon {\n  margin-left: auto;\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/driver-tariffs/tariffs-list/tariffs-list.component.scss
// module id = ./src/app/driver-tariffs/tariffs-list/tariffs-list.component.scss
// module chunks = main